import request from "@/utils/request";

/**
 * 【新】走势根据彩种查询菜单
 *
 * @description 【新】走势根据彩种查询菜单
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function queryAllDisplays(playload) {
  return request({
    url: "/api/lottery/trend/queryAllDisplays",
    method: "POST",
    data: playload,
    noEncrypt: true
  });
}
/**
 * 【新】走势根据彩种开奖号码
 *
 * @description
 *
 * 1.time时间为空情况下：num为空或者>200，最多查询最近200期。
 * 2.time时间不为空的情况下: num为空查询当天所有，num不为空最多查询200期。
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function queryOpencodes(playload) {
  return request({
    url: "/api/lottery/trend/queryOpencodes",
    method: "POST",
    data: playload,
    noEncrypt: true
  });
}
/**
 * 【新】走势查询所有彩种
 *
 * @description 【新】走势查询所有彩种
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function queryAllLotterys(playload) {
  return request({
    url: "/api/lottery/trend/queryAllLotterys",
    method: "POST",
    data: playload,
    noEncrypt: true
  });
}
/**
 * 查询切换计划信息
 *
 * @description 查询切换计划信息
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function queryLotPlan(playload) {
  return request({
    url: "/api/lottery/trend/queryLotPlan",
    method: "POST",
    data: playload,
    noEncrypt: true
  });
}
/**
 * 查询实施计划竞猜信息
 *
 * @description 查询实施计划竞猜信息
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function queryLotPlanLog(playload) {
  return request({
    url: "/api/lottery/trend/queryLotPlanLog",
    method: "POST",
    data: playload,
    loading: true,
    noEncrypt: true
  });
}
/**
 * 聊天室彩票计划长龙提醒
 *
 * @description 聊天室彩票计划长龙提醒
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function queryLotPlanQueue(playload) {
  return request({
    url: "/api/lottery/trend/queryLotPlanQueue",
    method: "POST",
    data: playload,
    loading: true,
    noEncrypt: true
  });
}
